export let powerPlants = [];

//Decentrale windenergie
powerPlants.push({
  id: 1,
  name: "Decentrale windenergie 1",
  mwu: 4,
  basePrice: 800,
  green: true,
  central: false,
  dependency: false,
  purchasedBy: false,
  demolished: false,
  external: false,
  image: "Decentral wind",
  imageStyle: [{
    width: "3%",
    transform: `translate(0,0)`,
  },{
    width: "3%",
    transform: `translate(0,-200%)`,
  }],
  icon: "Icon - windfarm",
});

powerPlants.push({
  id: 2,
  name: "Decentrale windenergie 2",
  mwu: 5,
  basePrice: 600,
  green: true,
  central: false,
  dependency: "Decentrale windenergie 1",
  purchasedBy: false,
  demolished: false,
  external: false,
  image: "Decentral wind",
  imageStyle: [{
    width: "3%",
    transform: `translate(0,0)`,
  },{
    width: "3%",
    transform: `translate(0,-200%)`,
  }],
  icon: "Icon - windfarm",
});

powerPlants.push({
  id: 3,
  name: "Decentrale windenergie 3",
  mwu: 6,
  basePrice: 500,
  green: true,
  central: false,
  dependency: "Decentrale windenergie 2",
  purchasedBy: false,
  demolished: false,
  external: false,
  image: "Decentral wind",
  imageStyle: [{
    width: "3%",
    transform: `translate(0,0)`,
  },{
    width: "3%",
    transform: `translate(0,-200%)`,
  }],
  icon: "Icon - windfarm",
});

//Decentrale zonneenergie
powerPlants.push({
  id: 4,
  name: "Decentrale zonne-energie 1",
  mwu: 3,
  basePrice: 600,
  green: true,
  central: false,
  dependency: false,
  purchasedBy: false,
  demolished: false,
  external: false,
  image: "Decentral solar",
  imageStyle: [{
    width: "4%",
    transform: `translate(-25%,0)`,
  },{
    width: "4%",
    transform: `translate(-25%,-378.4%)`,
  }],
  icon: "Icon - solarpower",
});

powerPlants.push({
  id: 5,
  name: "Decentrale zonne-energie 2",
  mwu: 4,
  basePrice: 500,
  green: true,
  central: false,
  dependency: "Decentrale zonne-energie 1",
  purchasedBy: false,
  demolished: false,
  external: false,
  image: "Decentral solar",
  imageStyle: [{
    width: "4%",
    transform: `translate(-25%,0)`,
  },{
    width: "4%",
    transform: `translate(-25%,-378.4%)`,
  }],
  icon: "Icon - solarpower",
});

powerPlants.push({
  id: 6,
  name: "Decentrale zonne-energie 3",
  mwu: 5,
  basePrice: 400,
  green: true,
  central: false,
  dependency: "Decentrale zonne-energie 2",
  purchasedBy: false,
  demolished: false,
  external: false,
  image: "Decentral solar",
  imageStyle: [{
    width: "4%",
    transform: `translate(-25%,0)`,
  },{
    width: "4%",
    transform: `translate(-25%,-378.4%)`,
  }],
  icon: "Icon - solarpower",
});

//Central windenergie
powerPlants.push({
  id: 7,
  name: "Windpark 1",
  mwu: 8,
  basePrice: 1600,
  green: true,
  central: true,
  dependency: false,
  purchasedBy: false,
  demolished: false,
  external: false,
  image: ["Windfarm", "Windfarm - internal"],
  imageStyle: [{
    width: "16.6%",
    transform: `translate(-20.1%, 26.4%)`,
  },{
    width: "11%",
    transform: `translate(-27.2%, 27.4%)`,
  }],
  hudStyle: [{
    //Groot
    width: (100 - 20.1) * 0.9 + "%",
    marginRight: (100 - 20.1) * 0.05 + "%"
  },{
    //Klein
    width: (100 - 27.2) * 0.9 + "%",
    marginRight: (100 - 27.2) * 0.05 + "%"
  }],
  icon: "Icon - windfarm",
});

powerPlants.push({
  id: 8,
  name: "Windpark 2",
  mwu: 12,
  basePrice: 1200,
  green: true,
  central: true,
  dependency: "Windpark 1",
  purchasedBy: false,
  demolished: false,
  external: false,
  image: ["Windfarm", "Windfarm - internal"],
  imageStyle: [{
    width: "16.6%",
    transform: `translate(-20.1%, 26.4%)`,
  },{
    width: "11%",
    transform: `translate(-27.2%, 27.4%)`,
  }],
  hudStyle: [{
    //Groot
    width: (100 - 20.1) * 0.9 + "%",
    marginRight: (100 - 20.1) * 0.05 + "%"
  },{
    //Klein
    width: (100 - 27.2) * 0.9 + "%",
    marginRight: (100 - 27.2) * 0.05 + "%"
  }],
  icon: "Icon - windfarm",
});

powerPlants.push({
  id: 9,
  name: "Windpark 3",
  mwu: 20,
  basePrice: 1000,
  green: true,
  central: true,
  dependency: "Windpark 2",
  purchasedBy: false,
  demolished: false,
  external: false,
  image: ["Windfarm", "Windfarm - internal"],
  imageStyle: [{
    width: "16.6%",
    transform: `translate(-20.1%, 26.4%)`,
  },{
    width: "11%",
    transform: `translate(-27.2%, 27.4%)`,
  }],
  hudStyle: [{
    //Groot
    width: (100 - 20.1) * 0.9 + "%",
    marginRight: (100 - 20.1) * 0.05 + "%"
  },{
    //Klein
    width: (100 - 27.2) * 0.9 + "%",
    marginRight: (100 - 27.2) * 0.05 + "%"
  }],
  icon: "Icon - windfarm",
});

//Central zonneenergie
powerPlants.push({
  id: 10,
  name: "Zonnepark 1",
  mwu: 8,
  basePrice: 1800,
  green: true,
  central: true,
  dependency: false,
  purchasedBy: false,
  demolished: false,
  external: false,
  image: ["Solarfarm", "Solarfarm - sea"],
  imageStyle: [{
    width: "14%",
    transform: `translate(-25.4%, 45.8%)`,
  },{
    width: "12%",
    transform: `translate(-2.1%, 46%)`,
  }],
  hudStyle: [{
    //Sea
    width: (100 - 2.1) * 0.9 + "%",
    marginRight: (100 - 2.1) * 0.05 + "%"
  },{
    //Land
    width: (100 - 25.4) * 0.9 + "%",
    marginRight: (100 - 25.4) * 0.05 + "%"
  }],
  icon: "Icon - solarpower",
});

powerPlants.push({
  id: 11,
  name: "Zonnepark 2",
  mwu: 10,
  basePrice: 1200,
  green: true,
  central: true,
  dependency: "Zonnepark 1",
  purchasedBy: false,
  demolished: false,
  external: false,
  image: ["Solarfarm", "Solarfarm - sea"],
  imageStyle: [{
    width: "14%",
    transform: `translate(-25.4%, 45.8%)`,
  },{
    width: "12%",
    transform: `translate(-2.1%, 46%)`,
  }],
  hudStyle: [{
    //Sea
    width: (100 - 2.1) * 0.9 + "%",
    marginRight: (100 - 2.1) * 0.05 + "%"
  },{
    //Land
    width: (100 - 25.4) * 0.9 + "%",
    marginRight: (100 - 25.4) * 0.05 + "%"
  }],
  icon: "Icon - solarpower",
});

powerPlants.push({
  id: 12,
  name: "Zonnepark 3",
  mwu: 14,
  basePrice: 1000,
  green: true,
  central: true,
  dependency: "Zonnepark 2",
  purchasedBy: false,
  demolished: false,
  external: false,
  image: ["Solarfarm", "Solarfarm - sea"],
  imageStyle: [{
    width: "14%",
    transform: `translate(-25.4%, 45.8%)`,
  },{
    width: "12%",
    transform: `translate(-2.1%, 46%)`,
  }],
  hudStyle: [{
    //Sea
    width: (100 - 2.1) * 0.9 + "%",
    marginRight: (100 - 2.1) * 0.05 + "%"
  },{
    //Land
    width: (100 - 25.4) * 0.9 + "%",
    marginRight: (100 - 25.4) * 0.05 + "%"
  }],
  icon: "Icon - solarpower",
});

//Central Kolencentrale
powerPlants.push({
  id: 13,
  name: "Kolencentrale 1",
  mwu: 14,
  basePrice: 1500,
  green: false,
  central: true,
  dependency: false,
  purchasedBy: false,
  demolished: false,
  external: false,
  image: ["Coalplant", "Coalplant - sea"],
  imageStyle: [{
    width: "11.8%",
    transform: `translate(-33.8%, 21.6%)`,
  },{
    width: "11.8%",
    transform: `translate(-28.2%, 26.1%)`,
  }],
  hudStyle: [{
    //Sea
    width: (100 - 28.2) * 0.9 + "%",
    marginRight: (100 - 28.2) * 0.05 + "%"
  },{
    //Land
    width: (100 - 33.8) * 0.9 + "%",
    marginRight: (100 - 33.8) * 0.05 + "%"
  }],
  icon: "Icon - powerplant",
});

powerPlants.push({
  id: 14,
  name: "Kolencentrale 2",
  mwu: 16,
  basePrice: 1000,
  green: false,
  central: true,
  dependency: "Kolencentrale 1",
  purchasedBy: false,
  demolished: false,
  external: false,
  image: ["Coalplant", "Coalplant - sea"],
  imageStyle: [{
    width: "11.8%",
    transform: `translate(-33.8%, 21.6%)`,
  },{
    width: "11.8%",
    transform: `translate(-28.2%, 26.1%)`,
  }],
  hudStyle: [{
    //Sea
    width: (100 - 28.2) * 0.9 + "%",
    marginRight: (100 - 28.2) * 0.05 + "%"
  },{
    //Land
    width: (100 - 33.8) * 0.9 + "%",
    marginRight: (100 - 33.8) * 0.05 + "%"
  }],
  icon: "Icon - powerplant",
});

//Central Gascentrale
powerPlants.push({
  id: 15,
  name: "Gascentrale 1",
  mwu: 16,
  basePrice: 2000,
  green: false,
  central: true,
  dependency: false,
  purchasedBy: false,
  demolished: false,
  external: false,
  image: ["Gasplant", "Gasplant - sea"],
  imageStyle: [{
    width: "11.8%",
    transform: `translate(-34.7%, 24.4%)`,
  },{
    width: "11.8%",
    transform: `translate(-30.8%, 26.6%)`,
  }],
  hudStyle: [{
    //Sea
    width: (100 - 30.8) * 0.9 + "%",
    marginRight: (100 - 30.8) * 0.05 + "%"
  },{
    //Land
    width: (100 - 34.7) * 0.9 + "%",
    marginRight: (100 - 34.7) * 0.05 + "%"
  }],
  icon: "Icon - gasplant   ",
});

powerPlants.push({
  id: 16,
  name: "Gascentrale 2",
  mwu: 18,
  basePrice: 1200,
  green: false,
  central: true,
  dependency: "Gascentrale 1",
  purchasedBy: false,
  demolished: false,
  external: false,
  image: ["Gasplant", "Gasplant - sea"],
  imageStyle: [{
    width: "11.8%",
    transform: `translate(-34.7%, 24.4%)`,
  },{
    width: "11.8%",
    transform: `translate(-30.8%, 26.6%)`,
  }],
  hudStyle: [{
    //Sea
    width: (100 - 30.8) * 0.9 + "%",
    marginRight: (100 - 30.8) * 0.05 + "%"
  },{
    //Land
    width: (100 - 34.7) * 0.9 + "%",
    marginRight: (100 - 34.7) * 0.05 + "%"
  }],
  icon: "Icon - gasplant   ",
});



// WEBPACK FOOTER //
// ./src/actions/powerPlantsArray.js